(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7681],{

/***/ 55502:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'quote-left';
var width = 448;
var height = 512;
var aliases = [8220,"quote-left-alt"];
var unicode = 'f10d';
var svgPathData = 'M0 216C0 149.7 53.7 96 120 96l8 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-8 0c-30.9 0-56 25.1-56 56l0 8 64 0c35.3 0 64 28.7 64 64l0 64c0 35.3-28.7 64-64 64l-64 0c-35.3 0-64-28.7-64-64l0-32 0-32 0-72zm256 0c0-66.3 53.7-120 120-120l8 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-8 0c-30.9 0-56 25.1-56 56l0 8 64 0c35.3 0 64 28.7 64 64l0 64c0 35.3-28.7 64-64 64l-64 0c-35.3 0-64-28.7-64-64l0-32 0-32 0-72z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.y1 = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 52097:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tv",
      function () {
        return __webpack_require__(12849);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 52929:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZE": function() { return /* binding */ setContentWithFallbacks; }
/* harmony export */ });
/* unused harmony export SEMIndexPageTemplate */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var capital_case__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(71292);
/* harmony import */ var _utils_string_utils__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(2638);
/* harmony import */ var _CityPhoneNumberData__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21611);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _fortawesome_pro_duotone_svg_icons_faCalendarCheck__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(52375);
/* harmony import */ var _fortawesome_pro_duotone_svg_icons_faCarMechanic__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(67170);
/* harmony import */ var _HowItWorksGreenCheckSection__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(43906);
/* harmony import */ var _ReviewsV2Section__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(18405);
/* harmony import */ var _getTitleFromUTMS__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(10090);
/* harmony import */ var ramda__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(61275);
/* harmony import */ var _Layout__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(22932);
/* harmony import */ var _ServicesHowItWorksSection__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(1948);
/* harmony import */ var _HappinessGuaranteeSection__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(28763);
/* harmony import */ var _CallUsNowBar__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(11667);
/* harmony import */ var _Forms_ScheduleServiceMultiStep_NoEmailScheduleServiceFormMultiStep__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(42786);
/* harmony import */ var _HeaderSection__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(79610);
/* harmony import */ var _fortawesome_pro_duotone_svg_icons_faMoneyCheckEditAlt__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(38510);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_14__);























var SEMIndexPageTemplate = function(param) {
    var phoneNumber = param.phoneNumber, formalCity = param.formalCity, phoneNumberTxt = param.phoneNumberTxt, _type = param.type, type = _type === void 0 ? "generic" : _type, content = param.content, make = param.make, rating = param.rating, reviewCount = param.reviewCount;
    var headerTitle = (0,_getTitleFromUTMS__WEBPACK_IMPORTED_MODULE_15__/* .getTitleFromUTMS */ .u)({
        formalCity: formalCity,
        phoneNumber: phoneNumber,
        phoneNumberTxt: phoneNumberTxt,
        type: type,
        content: content,
        make: make,
        rating: rating,
        reviewCount: reviewCount
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Layout__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        showFooter: false,
        showGetQuote: false,
        phoneNumber: phoneNumber,
        phoneNumberTxt: phoneNumberTxt,
        title: "Affordable Brake Repair Services".concat(formalCity ? " In ".concat(formalCity) : "", " | NuBrakes Mobile Brake Repair - We Come To You"),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: "Need new brakes? Stay at home and let a certified NuBrakes brake tech come to you and repair your brakes for less than most".concat(formalCity ? " ".concat(formalCity) : "", " brake shops and dealerships on average.")
                    }, "description"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "robots",
                        content: "noindex,nofollow"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_HeaderSection__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                rating: rating,
                formInitialProps: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)({}, _Forms_ScheduleServiceMultiStep_NoEmailScheduleServiceFormMultiStep__WEBPACK_IMPORTED_MODULE_12__/* .twDefaultInitialWizardFormValues */ .oA), {
                    "form-name": "semScheduleServiceForm"
                }),
                reviewCount: reviewCount,
                title: headerTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_HowItWorksGreenCheckSection__WEBPACK_IMPORTED_MODULE_5__/* .HowItWorksGreenCheckSection */ .x, {
                title: "Why NuBrakes?",
                first: {
                    title: "We Come To You",
                    subtitle: "Our mobile brake techs deliver top-rated brake repairs at your home or office for up to 40% less than a repair shop."
                },
                second: {
                    title: "Better Prices",
                    subtitle: "We're 40% more affordable on average compared to the dealerships and shops so you'll be saving time and money."
                },
                third: {
                    title: "Same-Day Availability",
                    subtitle: "Need your brakes repaired today? Same-day service is typically available — contact us to schedule!"
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ServicesHowItWorksSection__WEBPACK_IMPORTED_MODULE_9__/* .ServicesHowItWorksSection */ .S, {
                phoneNumber: phoneNumber,
                title: "How NuBrakes Works",
                description: "Schedule top-rated brake services in minutes.",
                steps: [
                    {
                        title: "Get Your Free Repair Quote",
                        description: "Let us know what’s going on with your brakes and we’ll send you a free, no obligation repair quote for your vehicle.",
                        image: _fortawesome_pro_duotone_svg_icons_faMoneyCheckEditAlt__WEBPACK_IMPORTED_MODULE_18__/* .faMoneyCheckEditAlt */ .v4
                    },
                    {
                        title: "Select Your Repair Date",
                        description: "Availability as early as today. Choose a repair date and time that works around your schedule.",
                        image: _fortawesome_pro_duotone_svg_icons_faCalendarCheck__WEBPACK_IMPORTED_MODULE_19__/* .faCalendarCheck */ .Ry
                    },
                    {
                        title: "Enjoy Safer, Better Driving",
                        description: "Our brake technicians will ensure that your brakes are ready to hit the road and get you back to driving worry-free!",
                        image: _fortawesome_pro_duotone_svg_icons_faCarMechanic__WEBPACK_IMPORTED_MODULE_20__/* .faCarMechanic */ .cC
                    }, 
                ],
                buttonText: "Get A Quote"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ReviewsV2Section__WEBPACK_IMPORTED_MODULE_6__/* .ReviewsV2Section */ .r, {
                title: "Over 1000+ 5-Star Reviews",
                first: {
                    review: "We received fantastic, quick service, at a fair price. We got quite a few quotes and NuBrakes was the best price and it turns out, the quickest and best service. Our technician, Mike, was knowledgeable and friendly and got the job done quickly - all at my office. We would definitely recommend them and use the service again.",
                    from: "".concat(formalCity),
                    reviewer: "Tami F."
                },
                second: {
                    from: "".concat(formalCity),
                    reviewer: "Clinton B.",
                    review: "This service is awesome. You are paying for fast, convenient and good quality work. Communication with Walker was immediate and the technician Micheal was done in half the time that was quoted. I will use NuBrakes again in the future and recommend it to everyone. I mean, they come to you, that was what sold it for me."
                },
                third: {
                    review: "Without a doubt would recommend NuBrakes to anyone that needs brakes done. Service tech showed up on time and was professional and quick. And the conveniences having them come to you is hard to beat. Not to mention the price is close to half what you’d pay at a pep boys or any other body shop. Can’t beat it.",
                    from: "".concat(formalCity),
                    reviewer: "William T."
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_HappinessGuaranteeSection__WEBPACK_IMPORTED_MODULE_10__/* .HappinessGuaranteeSection */ .M, {
                title: "Happiness Guaranteed",
                description: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        "Our brake techs have decades of combined experience, and all services are backed by our",
                        " ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_14___default()), {
                            href: "/warranty",
                            children: "NuBrakes Guarantee"
                        }),
                        "."
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CallUsNowBar__WEBPACK_IMPORTED_MODULE_11__/* .CallUsNowBar */ .y, {
                phoneNumber: phoneNumber
            })
        ]
    });
};
function setContentWithFallbacks(type, content) {
    if (content !== "undefined") {
        return content;
    }
    switch(type){
        case "generic":
            return "";
        case "comp":
            return "brake shop";
        case "vehicle":
            return "";
        case "vehicle-part":
            return "brake-parts";
        case "mm_generic":
            return "auto-parts";
        case "mm_vehicle-part":
            return "auto-parts";
        default:
            return "";
    }
}
var SEMPage = function(param) {
    var _rating = param.rating, rating = _rating === void 0 ? "4.94" : _rating, _reviewCount = param.reviewCount, reviewCount = _reviewCount === void 0 ? 6013 : _reviewCount;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    var query = router.query;
    var city = (0,ramda__WEBPACK_IMPORTED_MODULE_7__/* .propOr */ .Uth)("", "city", query);
    var type = (0,ramda__WEBPACK_IMPORTED_MODULE_7__/* .propOr */ .Uth)("", "type", query);
    var make = (0,ramda__WEBPACK_IMPORTED_MODULE_7__/* .propOr */ .Uth)("", "make", query);
    var content = (0,ramda__WEBPACK_IMPORTED_MODULE_7__/* .propOr */ .Uth)("", "utm_content", query);
    content = setContentWithFallbacks(type, content);
    var formalCity = city ? capital_case__WEBPACK_IMPORTED_MODULE_21__/* .capitalCase */ .I(city) : "";
    var phoneNumber = city && _CityPhoneNumberData__WEBPACK_IMPORTED_MODULE_3__/* .CityPhoneNumberData */ .L[city] ? _CityPhoneNumberData__WEBPACK_IMPORTED_MODULE_3__/* .CityPhoneNumberData */ .L[city].phoneNumber : _CityPhoneNumberData__WEBPACK_IMPORTED_MODULE_3__/* .CityPhoneNumberData["default"].phoneNumber */ .L["default"].phoneNumber;
    var phoneNumberTxt = (0,_utils_string_utils__WEBPACK_IMPORTED_MODULE_22__/* .formatPhoneNumber */ .u)(phoneNumber);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SEMIndexPageTemplate, {
        rating: rating,
        reviewCount: reviewCount,
        phoneNumberTxt: phoneNumberTxt,
        phoneNumber: phoneNumber,
        formalCity: formalCity,
        content: content,
        type: type,
        make: make
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (SEMPage);


/***/ }),

/***/ 12849:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _components_SEMPage_sem_old__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52929);

/* harmony default export */ __webpack_exports__["default"] = (_components_SEMPage_sem_old__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4976,2978,4231,7858,4024,2932,6566,6263,7187,9774,2888,179], function() { return __webpack_exec__(52097); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);